import { Reaction } from '@instamenu/data-access-stats';
import { RowData, ColumnHelper } from '@tanstack/react-table';

export const reactionEmoji = (reaction: Pick<Reaction, 'isPositive'>) => {
  if (!reaction) return '';
  if (reaction.isPositive === true) return '😀';
  if (reaction.isPositive === false) return '😡';
  return '😐';
};

export function reactionColumn<T extends RowData>(
  columnHelper: ColumnHelper<T>,
  accesorKey: Parameters<ColumnHelper<T>['accessor']>[0],
) {
  return columnHelper.accessor(accesorKey, {
    header: '🤔',
    cell: ({ cell }) => {
      const value = cell.getValue();
      if (!value) return null;
      return reactionEmoji(value);
    },
    sortingFn: (rowA, rowB, id: string) => {
      const direction = rowA._getAllCellsByColumnId()[id].column.getIsSorted() === 'desc' ? 1 : -1;
      const toOrder = (value: Reaction) => {
        if (!value) return direction ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
        if (value.isPositive) return 1;
        return -1;
      };
      const a = toOrder(rowA.getValue(id));
      const b = toOrder(rowB.getValue(id));
      return a === b ? 0 : a < b ? -1 : 1;
    },
  });
}
